<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="wordType" style="overflow-y: auto;">
        <div class="backBox">
          <button class="btn btn-back" @click="examHide">返回</button>
        </div>
        <div class="content-item" v-for="(item,index) in addObj.practice" :key="index"  v-loading="loading" :element-loading-text="loadTxt">
          <div class="write-txt">
            <p class="title">题目{{(index+1)}}</p>
            <button class="btn btn-topic-remove" v-if="index>0" @click="examRemove(index)">删除</button>
            <!-- <button class="btn btn-topic-ai" @click="aiTopic(item)">AI出题</button> -->
          </div>
          <div class="write-txt">
            <p class="write-title">选择词义：<span>*</span></p>
            <div class="write-text">
              <el-select v-model="item.sense" placeholder="请选择">
                <el-option
                  v-for="item in addObj.senses"
                  :key="item.sense"
                  :label="item.sense"
                  :value="item.sense"
                >
                </el-option>
              </el-select>
              <button class="btn btn-topic-ai" @click="aiTopic(item)">AI出题</button>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">题干：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.topic_title"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">选项：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.option"></textarea>
            </div>
          </div>
          <div class="write-txt">
            <p class="write-title">答案：<span>*</span></p>
            <div class="write-text">
              <textarea placeholder="" v-model="item.answer"></textarea>
            </div>
          </div>
        </div>
        <button class="btn btn-add" @click="addTopic">+添加题目</button>
        <div class="write-btnBox">
          <button class="btn btn-save" @click="topicSub">保存</button>
          <button class="btn btn-close" @click="examHide">取消</button>
        </div>
      </div>

      <div class="MobelBox" v-else-if="addType">
        <div class="" style="display: block;height: 100%;overflow-y: auto;">
          <div class="content-item">
            <div class="write-txt">
              <p class="write-title">词：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.name"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">记忆法：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.mnemonic"></textarea>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">上传图片：<span>*</span></p>
              <div class="write-text">
                <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="addObj.image">
                  <img :src="'https://pic.speechcoach.cn/'+addObj.image" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="icon-delete" @click="imgRemove"></i>
                  </div>
                </div>
                <el-upload
                  :action="'https://upload.qiniup.com'"
                  :data="uploadObj"
                  list-type="picture-card"
                  :before-upload="beforeUploadImg"
                  :on-success="(response, file, fileList)=>{return handleSuccessImg(response, file, fileList)}"
                  :on-progress="handleProgressImg"
                  :on-remove="handleRemoveImg"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img
                    width="100%"
                    :src="'https://pic.speechcoach.cn/' + addObj.image"
                    alt=""
                  />
                </el-dialog>
              </div>
            </div>  
            <div class="wordList">
              <div class="word-item" v-for="(item,index) in addObj.senses" :key="index">
                <div class="write-txt">
                  <p class="write-title">词义{{(index+1)}}：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.sense"></textarea>
                    <button class="btn btn-word-remove" v-if="index>0" @click="removeWord(index)">删除</button>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">词性{{(index+1)}}：</p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.nature"></textarea>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">例句{{(index+1)}}：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.example"></textarea>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">例句{{(index+1)}}拼音：</p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.pinyin"></textarea>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">例句{{(index+1)}}出处：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.source"></textarea>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">例句{{(index+1)}}翻译：<span>*</span></p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.translation"></textarea>
                  </div>
                </div>
                <div class="write-txt">
                  <p class="write-title">关键词{{(index+1)}}：</p>
                  <div class="write-text">
                    <textarea placeholder="" v-model="item.keyword"></textarea>
                  </div>
                </div>
              </div>
              <button class="btn btn-add" @click="addWord">+添加词义</button>
            </div>
            <div class="write-txt write-setup">
              <p class="write-title">设置练习：<span>*</span></p>
              <div class="write-text">
                <button class="btn btn-setup" @click="examShow">去设置</button>
                <p >练习题共{{addObj.practice.length}}道</p>
              </div>
            </div>
          </div>

          <div class="write-btnBox">
            <button class="btn btn-save" @click="saveSub">保存</button>
            <button class="btn btn-close" @click="closeSub">取消</button>
          </div>
        </div>
      </div>
      
      <div class="organiza-txt"  v-loading="loading" :element-loading-text="loadTxt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加实词虚词</p>
          </div>
          <div class="organiza-left" style="background-color: #333333;color: #fff;margin-left: 30px;">
            <el-upload
              class="upload-demo btn btn-import"
              :action="url+'admin/Word/importWord'"
              :data="{lid:obj.lid}"
              :headers="{'userToken':token}"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept=".xls, .xlsx"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">上传文档</el-button>
            </el-upload>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.id">{{item.id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mnemonic">{{item.mnemonic}}</p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.add_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" style="color: #FF1919;" class="btn btn-remove" @click="removeShow(item)">删除</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      <div class="msgBox" v-if="removeType">
        <div class="contv">
          <p class="title">是否确定删除？</p>
          <div class="btnBox">
            <button class="btn btn-close" @click="removeHide">取消</button>
            <button class="btn btn-sub" @click="removeSub">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWordList,getLibraryDetail,getUploadToken ,aiSetQuestions ,saveWord ,delWord ,getWordDetail} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'1',
      childrenID:'1-1',
      titleList:[
        {id:1,title:'ID'},
        {id:2,title:'词'},
        {id:3,title:'记忆法'},
        {id:4,title:'排序'},
        {id:5,title:'添加时间'},
        {id:6,title:'操作'},
      ],
      dataList:[
      ],
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        lid:'',
        name:'',
        mnemonic:'',
        image:'',
        senses:[
          {sense:'',example:'',keyword:''}
        ],
        practice:[
          {
            sense:'',
            topic_title:'',
            option:'',
            answer:''
          }
        ]
      },
      totalPage:0,
      url:'',
      reviewType:false,
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      wordType:false,
      wordList:[],
      senseList:[],
      questionsObj:{
        name:'',
        sense:'',
      },
      wordIndex:'',
      loadTxt:'',
      loading:false,
      addType:'',
      removeType:false,
      removeID:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.obj.lid = this.$route.query.lid;
    this.addObj.lid = this.$route.query.lid;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.obj,this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async getList(){
      var that = this;
      try {
        const response = await getWordList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getWordDetail({id:e.id},this.token);
        if(response.code == 200){
          response.data.practice.forEach(function(item,index){
            item.option = 'A.' + item.option_A + '\rB.' + item.option_B + '\rC.' + item.option_C + '\rD.' + item.option_D
          })
          that.addObj = response.data;
          if(that.addObj.practice.length == 0){
            that.addObj.practice = [
              {
                sense:'',
                topic_title:'',
                option:'',
                answer:''
              }
            ]
          }
          that.addType = 'edit';    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    beforeUpload(){
      this.loading = true;
      this.loadTxt = '上传中，请稍后....'
    }, 

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请填写词');
        return false;
      }
      if(this.addObj.mnemonic == ''){
        that.$message('请填写记忆法');
        return false;
      }
      if(this.addObj.image == ''){
        that.$message('请上传图片');
        return false;
      }
      // try {
      //     this.addObj.senses.forEach(function(item,index){
      //       if(item.sense == ''){
      //         that.$message('请填写词义'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //       if(item.example == ''){
      //         that.$message('请填写例句'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //       if(item.keyword == ''){
      //         that.$message('请填写关键词'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //     });
      //     this.addObj.practice.forEach(function(item,index){
      //       if(item.sense == ''){
      //         that.$message('请填写词义'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //       if(item.topic_title == ''){
      //         that.$message('请填写题干'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //       if(item.option == ''){
      //         that.$message('请填写选项'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //       if(item.answer == ''){
      //         that.$message('请填写答案'+(index+1));
      //         throw new Error("EndIterative");
      //       }
      //     });
      // } catch(e) {
      //     if (e.message != "EndIterative") {
      //         throw e;
      //     } else {
      //         return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
      //     }
      // };
      try {
        const response = await saveWord(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          window.location.reload();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    closeSub(){
      this.addType = '';
      this.addObj={
        lid:'',
        name:'',
        mnemonic:'',
        image:'',
        senses:[
          {sense:'',example:'',keyword:''}
        ],
        practice:[
          {
            sense:'',
            topic_title:'',
            option:'',
            answer:''
          }
        ]
      };
      this.addObj.lid = this.$route.query.lid;
    },
    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.loading = false;
        that.uploadObj.key = '';
        that.getList();
      } else {
        that.$message(response.msg);
      }
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    handleSuccessImg(response, file, fileList,index,e,type) {
      var that = this;
      this.addObj.image = response.key;
      that.$forceUpdate();
      that.loading = false;
      that.uploadObj.key = "";
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    handleRemoveImg() {
      this.uploadUrl = "";
      this.addObj.image = "";
      that.uploadObj.key = "";
    },

    beforeUploadImg(file) {
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    addWord(e){
      this.addObj.senses.push(
        {sense:'',example:'',keyword:''}
      );
      this.$forceUpdate();
    },

    removeWord(e,index){
      this.addObj.senses.splice(e,1);
      this.$forceUpdate();
    },

    examShow(e,index){
      this.wordType = true;
    },
    
    examHide(){
      this.wordType = false;
    },

    examRemove(index){
      this.addObj.practice.splice(index,1);
    },

    addTopic(){
      this.addObj.practice.push(
        {
          sense:'',
          topic_title:'',
          option:'',
          answer:''
        }
      )
    },

    async aiTopic(e){
      var that = this;
      this.loadTxt = 'AI出题中，请稍后';
      this.loading = true;
      this.questionsObj = {
        name : this.addObj.name,
        sense : e.sense,
        type:1
      }
      try {
        const response = await aiSetQuestions(this.questionsObj,this.token);
        if(response.code == 200){
            e.answer = response.data.topic.answer;
            e.topic_title = response.data.topic.topic;
            e.option = 'A.' + response.data.topic.option_A + '\rB.' + response.data.topic.option_B + '\rC.' + response.data.topic.option_C + '\rD.' + response.data.topic.option_D
            that.loadTxt = '';
            that.loading = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicSub(){
      var that = this;
      try {
        this.addObj.practice.forEach(function(item,index){
          if(item.sense == ''){
            that.$message('请选择题目'+(index+1)+'词义');
            throw new Error("EndIterative");
          }
          if(item.topic_title == ''){
            that.$message('请填写题目'+(index+1)+'题干');
            throw new Error("EndIterative");
          }
          if(item.option == ''){
            that.$message('请填写题目'+(index+1)+'选项');
            throw new Error("EndIterative");
          }
          if(item.answer == ''){
            that.$message('请填写题目'+(index+1)+'答案');
            throw new Error("EndIterative");
          }
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      this.wordType = false;
    },
    
    numCheck(e,i,type){
      var that = this;
      var num = e.sentence;
      num = num.length;
      if(num > i){
          if(type == 'sentence'){
              e.sentence = e.sentence.slice(0,i);
              that.$forceUpdate();
              that.$message('已超出128个字数');
              return false;
          }
      }
    },

      removeShow(e){
        this.removeID = e.id;
        this.removeType = true;
      },

      async removeSub(){
        var that = this;
        try {
          const response = await delWord({id:this.removeID},this.token);
          if(response.code == 200){
            that.$message('删除成功');
            that.removeType = false;
            that.removeID = '';
            that.getList();
          } else {
            that.$message(response.msg);
          }
        } catch (error) {
          that.$message(error);
        }
      },

      removeHide(){
        var that = this;
        that.removeType = false;
        that.removeID = '';
      },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 6 );
  }

  .dataList .listItem p .btn{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
    overflow: hidden;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
    position: relative;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox .write-text .btn-word-remove{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .MobelBox .write-text .btn{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    position: absolute;
    /* 
    right: 0;
    top: 0; */
  }

  .MobelBox .write-text .btn.btn-keywords-add,
  .MobelBox .write-text .btn.btn-poetry-add{
      left: 600px;
      top: 0;
      background-color: transparent;
      border: solid 1px #00C7A3;
      color: #00C7A3;
  }

  .MobelBox .write-text .btn.btn-keywords-remove,
  .MobelBox .write-text .btn.btn-poetry-remove{
    left: 800px;
    top: 0;
  }

  .MobelBox .write-text .btn.btn-keywords-remove{
    left: 850px;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 550px;
    height: 330px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .MobelBox .poetry-txt textarea{
    /* width: 550px;
    height: 330px; */
  }
  
  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .msgBox .cont .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }

  .msgBox .cont .write-text{
    display: inline-block;
    vertical-align: top;
  }

  .msgBox .cont>>> .el-input--suffix .el-input__inner{
    width: 300px;
  }

  .msgBox .btnBox{
    margin-top: 30px;
  }

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.write-txt .title{
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
}

.write-txt .btn-topic-ai,
.write-txt .btn-topic-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 36px;
}

.MobelBox .write-text .btn.btn-topic-ai{
  background-color: #00C7A3;
  color: #fff;
}

.write-txt .btn-topic-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  border: solid 1px #00C7A3;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 24px;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}

.content-item{
  display: block;
  margin-bottom: 70px;
}

.write-setup{
  margin-top: 30px;
}

.write-setup .write-text p{
  color: #777777;
  font-size: 12px;
  display: inline-block;
  line-height: 39px;
  height: 39px;
  vertical-align: top;
  margin-left: 20px;
}

.MobelBox .write-text .btn.btn-setup{
  font-size: 16px;
  color: #fff;
  background-color: #00C7A3;
  border-radius: 6px;
  box-sizing: border-box;
  position: relative;
  height: 39px;
  line-height: 39px;
}

.backBox .btn-choose{
  background-color: #00C7A3;
  border-radius: 8px;
  color: #fff;
  font-size: 22px;
  box-sizing: border-box;
  padding: 10px 24px;
  float: right;
}

.word-item{
  border-bottom: 2px dashed #AAAAAA;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/resource/content.vue